import { render, staticRenderFns } from "./HomeFavouriteKits.vue?vue&type=template&id=779c4c45&scoped=true&"
import script from "./HomeFavouriteKits.vue?vue&type=script&lang=ts&"
export * from "./HomeFavouriteKits.vue?vue&type=script&lang=ts&"
import style0 from "./HomeFavouriteKits.vue?vue&type=style&index=0&id=779c4c45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779c4c45",
  null
  
)

export default component.exports